exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pageWrapper--RzGZT{min-height:50vh;padding:0 0 50px}.contentBody--2ef0n{max-width:837px;margin:0 auto;padding:24px 0 0;display:flex;flex-direction:column;gap:24px}@media(max-width:768px){.contentBody--2ef0n{padding:16px 12px 0;gap:24px}}", ""]);

// Exports
exports.locals = {
	"pageWrapper": "pageWrapper--RzGZT",
	"contentBody": "contentBody--2ef0n"
};